import axios from 'axios';
import localforage from 'localforage';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

localforage.config({
  name: 'jtrainer',
});

Vue.config.productionTip = false;

Vue.prototype.$http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL, // in .env or env.development
  // headers: { Authorization: 'Bearer {token }' },
});

Vue.prototype.$local = localforage;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
